<template>
    <b-container fluid class="p-0">
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">{{ tituloPagina }}</span>
                    <btn-voltar />
                </h6>
            </template>
            <b-tabs v-model="abaAtiva" card>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" />
                        Dados Evento
                    </template>
                    <aba-editar-dados-evento v-if="showForm && abaAtiva === 0" @atualizarEvento="atualizarEvento"
                        :evt="evt" />
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import AbaEditarDadosEvento from '@/components/licitacoes/eventos/editar-evento/AbaEditarDadosEvento.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import eventoService from '@/services/licitacoes/eventosService'
import { store } from "@/store"
import { Evento } from '@/types/eventos/eventos/evento'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarEvento',
    components: {
        AbaEditarDadosEvento, BtnVoltar
    },
    props: {
        idEvento: {
            type: String,
            default: ''
        }
    },
})

@Component
export default class EditarEvento extends mixins(UtilsTS, CompProps) {
    evt: Evento = new Evento()
    isEdit = false
    abaAtiva = 0 // qual aba está ativa no momento
    showForm = false

    get tituloPagina(): string {
        return `${this.isEdit ? 'Editar' : 'Criar'} Evento`
    }

    get mostrarBtnSave(): boolean {
        return this.abaAtiva === 0
    }

    async mounted(): Promise<void> {
        try {
            store.blockScreen = true
            if (this.idEvento.length > 0) {
                this.isEdit = true
                this.evt = await eventoService.buscarEvento(this.idEvento)
                this.evt.tratarDadosDaAPI()
            }
        }
        catch (e: unknown) {
            console.error('Erro ao abrir a edição de evento', e)
        } finally {
            this.showForm = true
            store.blockScreen = false
        }
    }

    /**
     * Vamos tentar centralizar aqui as mudanças em flags de controle e no objeto principal 'contrato'
     * @param co nova instância de contrato, recém recebida da API
     */
    async atualizarEvento(ev?: Evento): Promise<void> {
        store.blockScreen = true
        try {
            if (!ev) ev = await eventoService.buscarEvento(this.idEvento ?? this.evt.IdEvento)
            this.evt = Object.assign(new Evento(), ev)
            if (ev.IdEvento > 0) this.isEdit = true
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>